/* eslint-disable no-else-return */
/* eslint-disable no-lonely-if */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { Controller } from "react-hook-form";
import {
    Autocomplete,
    TextField,
    Checkbox,
    List,
    ListItem,
    Divider,
    Tooltip,
} from "@mui/material";
import { useState, useMemo, useEffect } from "react";
import CircularProgress from '@mui/material/CircularProgress';




const custom = ({
    handleSelectAction,
    field,
    inputValue,
    isAllFilteredSelected,
    isAllSelected,
    getSelectActionLabel,
    ...props
}) => (
    <List {...props} style={{ background: "white", color: "black" }}>
        <ListItem
            onMouseDown={(event) => event.preventDefault()} // Prevent focus loss
            onClick={() => handleSelectAction(field)} // Pass field to update form values
            sx={{
                display: "flex",
                height: "2rem",
                alignItems: "center",
                paddingLeft: "1.9em",
                fontSize: "13px",
            }}
        >
            <Checkbox
                checked={inputValue ? isAllFilteredSelected : isAllSelected}
                style={{ marginRight: 8 }}
                size="small"
            />
            <span style={{ fontSize: "13px" }}> {getSelectActionLabel()} </span>  {/* Make sure this is accessible */}
        </ListItem>
        <Divider />
        {props.children}
    </List>
);



const RHFAutocomplete = ({ formData, control, getDataFunc }) => {

    const [loading, setLoading] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [options, setOptions] = useState(formData?.DefaultValues || []);
    const [debounceTimeout, setDebounceTimeout] = useState(null);



    const filteredOptions = useMemo(() => {
        if (!inputValue) return options;
         //  console.log("filteredOptionsFun options:", options);
         //  console.log("filteredOptionsFun formData:", formData);
        return options?.filter((option) =>
            option[formData.DisplayExpr]
                ?.toLowerCase()
                ?.includes(inputValue.toLowerCase())
        );
    }, [options, inputValue, formData.DisplayExpr]);



    const rules = formData?.Validations?.reduce((acc, validation) => {
        if (validation.ValidationType === "Required") {
            acc.required = validation.ValidationMessage || "This field is required";
        }
        return acc;
    }, {});

    useEffect(() => {
        // If the field value changes programmatically (like through reset), update selectedOptions
        if (control._formValues && control._formValues[formData?.ValueExpr]) {
            const newSelectedOptions = options.filter((item) =>
                (control._formValues[formData?.ValueExpr] || []).includes(item[formData.ValueExpr])
            );
            setSelectedOptions(newSelectedOptions);
        }
    }, [control._formValues, formData.ValueExpr, options]);


    const isAllSelected = selectedOptions?.length === options?.length && options?.length !== 0;
    const isAllFilteredSelected = selectedOptions?.length > 0 && filteredOptions.every((option) =>
        selectedOptions.some(
            (selected) => selected[formData.ValueExpr] === option[formData.ValueExpr]
        )
    );

    const handleSelectAction = (field) => {
        if (inputValue) {
            if (isAllFilteredSelected) {
                // Unselect filtered options
                const updatedOptions = selectedOptions.filter(
                    (selected) =>
                        !filteredOptions.some(
                            (filtered) =>
                                filtered[formData.ValueExpr] === selected[formData.ValueExpr]
                        )
                );
                setSelectedOptions(updatedOptions);
                field.onChange(updatedOptions.map((item) => item[formData.ValueExpr]));
            } else {
                // Select filtered options
                const newSelectedOptions = [
                    ...selectedOptions,
                    ...filteredOptions.filter(
                        (filtered) =>
                            !selectedOptions.some(
                                (selected) =>
                                    selected[formData.ValueExpr] === filtered[formData.ValueExpr]
                            )
                    ),
                ];
                setSelectedOptions(newSelectedOptions);
                field.onChange(newSelectedOptions.map((item) => item[formData.ValueExpr]));
            }
        } else {
            if (isAllSelected) {
                // Unselect all
                setSelectedOptions([]);
                field.onChange([]);
            } else {
                // Select all
                setSelectedOptions(options);
                field.onChange(options.map((item) => item[formData.ValueExpr]));
            }
        }
    };


    const getSelectActionLabel = () => {
        if (inputValue) {
            return isAllFilteredSelected
                ? "Unselect Filtered Options"
                : "Select Filtered Options";
        } else {
            return isAllSelected ? "Unselect All" : "Select All";
        }
    };

    const fetchData = async (query) => {

        setLoading(true);
        let response = null;

        if (formData?.TableName === 'ManualContractClaimGeneration' && formData?.DisplayExpr === 'ContractName') {
            response = await getDataFunc({
                "SearchText": query
            });

        }
        else if (formData?.TableName === 'ClaimPreview') {
             //  console.log("Step 2")
            response = await getDataFunc({
                "SearchText": query
            });

        }
        else {
            response = await getDataFunc({
                "ControlId": `${formData?.TableName}-${formData?.DisplayExpr}`,
                "Values": query,
            });
        }

        let newOptions = null;
        if (formData?.TableName === 'ManualContractClaimGeneration' && formData?.DisplayExpr === 'ContractName') {
            newOptions = Array.isArray(response?.data?.DefaultValues) ? response?.data?.DefaultValues : [];
        }
        else if (formData?.TableName === 'ClaimPreview') {
             //  console.log("Step 3")
            newOptions = Array.isArray(response?.DefaultValues) ? response?.DefaultValues : [];
        }
        else {
            newOptions = Array.isArray(response?.data) ? response?.data : [];
        }



        // Filter out options that already exist in the current options state
        setOptions((prevOptions) => {
            const newUniqueOptions = newOptions.filter((newOption) =>
                !prevOptions.some((existingOption) => existingOption[formData.ValueExpr] === newOption[formData.ValueExpr])
            );
            return [...prevOptions, ...newUniqueOptions]; // Add the new unique options
        });
        setLoading(false);

    };

    useEffect(() => {
         //  console.log("Options:", options);
    }, [options])

    return (
        <Controller
            name={formData?.ValueExpr}
            control={control}
            rules={rules}
            render={({ field: { ref, ...field }, fieldState: { error } }) => ( // NOSONAR

                <Autocomplete
                    {...field}
                    multiple
                    options={options}
                    loading={loading}

                    value={options.filter(item => (field?.value || []).includes(item[formData?.ValueExpr]))}
                    inputValue={inputValue}
                    // onInputChange={handleInputChange}
                    onInputChange={(event, newInputValue, reason) => {
                        if (reason !== 'reset') {
                            setInputValue(newInputValue);

                            // If there's a previous debounce timeout, clear it
                            if (debounceTimeout) {
                                clearTimeout(debounceTimeout);
                            }

                            // Set a new timeout for the fetch call
                            const newTimeout = setTimeout(() => {
                                if (newInputValue.length >= 3) {
                                    fetchData(newInputValue);
                                }
                            }, 500); // Set delay to 500ms (can be adjusted)

                            setDebounceTimeout(newTimeout);
                        }
                    }}
                    getOptionLabel={(option) => option[formData.DisplayExpr] || ""}
                    isOptionEqualToValue={(option, value) =>
                        option[formData.ValueExpr] === value[formData.ValueExpr]
                    }
                    onChange={(event, value, reason) => {

                        if (!(reason === 'removeOption' && event.type === 'keydown')) {

                            //  console.log('value here ', value);
                            setSelectedOptions(value);
                            //  console.log('formData', formData);
                            field.onChange(value.map((item) => item[formData.ValueExpr]));
                            //  console.log('map ', value.map((item) => item[formData.ValueExpr]))
                        }
                    }}
                    disableCloseOnSelect
                    renderOption={(props, option, { selected }) => (
                        <li {...props} style={{ fontSize: "13px" }} key={option[formData?.ValueExpr]}>
                            <Checkbox style={{ marginRight: 8 }} checked={selected} size='small' />
                            {option[formData.DisplayExpr]}
                        </li>
                    )}
                    renderTags={(selected, getTagProps) => {
                        const label =
                            selected.length > 0 ? `${selected.length} items selected` : "";
                        return (
                            <span style={{ fontSize: "13px", paddingLeft: "0.5em" }}>
                                {label}
                            </span>
                        );
                    }}

                    slots={{
                        paper: custom,
                    }}
                    slotProps={{
                        paper: {
                            handleSelectAction,
                            field,
                            inputValue,
                            isAllFilteredSelected,
                            isAllSelected,
                            getSelectActionLabel,
                        },
                    }}

                    PaperComponent={custom}


                    renderInput={(params) => (
                        <Tooltip
                            title={
                                <div
                                    style={{
                                        maxHeight: '150px',
                                        overflowY: field?.value != null && field.value?.length > 3 ? 'auto' : 'hidden', // Show scrollbar only if there are more than 3 items
                                    }}
                                >
                                    <span
                                        style={{
                                            color: '#9e9e9e',
                                            fontSize: '13px',
                                            fontWeight: '300',
                                        }}
                                    >
                                        {options.filter(item => (field?.value || []).includes(item[formData?.ValueExpr])).map(item => item[formData.DisplayExpr]).join(", ")}

                                    </span>
                                </div>
                            }
                            arrow
                            placement="top"
                            PopperProps={{
                                sx: {
                                    '& .MuiTooltip-tooltip': {
                                        backgroundColor: 'white', // White background
                                        color: 'black', // Black text
                                        border: '1px solid #ccc', // Optional: subtle border for better visibility
                                        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1), 0px 4px 4px rgba(0, 0, 0, 0.25)',
                                    },
                                    '& .MuiTooltip-arrow': {
                                        color: 'white', // Match the arrow color with the tooltip background
                                    },
                                    display: field.value == null || field.value?.length === 0 ? 'none' : ''
                                },
                            }}
                        >
                            <TextField
                                {...params}
                                label={<>{formData?.LabelName || formData?.DisplayExpr}{rules?.required && (
                                    <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                                )}</>}
                                inputRef={ref}
                                variant="outlined"
                                size="small"
                                // error={!!error}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}

                                helperText={
                                    error && <span style={{ color: "red", fontSize: "10px" }}>{error.message}</span>
                                }
                                fullWidth
                                sx={{
                                    "& .MuiInputBase-input": {
                                        fontSize: "13px",
                                    },
                                    "& .MuiFormLabel-root": {
                                        fontSize: "14px",
                                    },
                                }}
                            />
                        </Tooltip>
                    )}
                />


            )}
        />
    );
};

export default RHFAutocomplete;
